// style

import '@ant-design/v5-patch-for-react-19';

import './init';
import React from 'react';
import 'react-circular-progressbar/dist/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import { createRoot } from 'react-dom/client';
import App from './App';
import './assets/sass/app/app.scss';
import { generateA11ySnapshot } from '@vl-common/a11ySnapshotHelper';

if (window.Cypress) {
  window.generateA11ySnapshot = generateA11ySnapshot;
}

if (typeof window !== 'undefined' && window.Cypress) {
  document.body.classList.add('e2e-scroll-on-body');
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
